import { combineReducers } from "redux";

import main from "./main";
import user from "./user";
import reportCampaign from "./reportCampaign";
import categoryUserSitePublisher from "./categoryUserSitePublisher";
import bannerGenerator from "./bannerGenerator";

export default combineReducers({
  reportCampaign,
  categoryUserSitePublisher,
  bannerGenerator,
  user,
  main,
});
